exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-menu {\n  background: #2CC185;\n  color: white;\n  width: 100%;\n  overflow: hidden;\n  padding: .2em 1em 0; }\n\n.top-menu-item {\n  overflow: hidden;\n  font-size: 1em;\n  width: 7em;\n  float: left;\n  cursor: pointer;\n  background-color: #2CC185;\n  color: white;\n  padding: .7em 0 .6em;\n  margin: 0 .2em 0;\n  text-align: center;\n  border-radius: 3px 3px 0 0;\n  text-decoration: none; }\n  .top-menu-item.active {\n    background-color: white;\n    color: #2CC185; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/container/views/TopMenuComponent/topMenu.component.scss
// module id = ./src/app/modules/container/views/TopMenuComponent/topMenu.component.scss
// module chunks = main